// How norm codes and norm notes read on screen: as the ЛСР prints them, in the estimator's words.

const BASES: Record<string, string> = { gesn: "ГЭСН", gesnm: "ГЭСНм", gesnmr: "ГЭСНмр", gesnp: "ГЭСНп", gesnr: "ГЭСНр" };

/** «gesn 10-01-047-01» → «ГЭСН10-01-047-01», as гр.2 of the ЛСР; any other code stays as stored. */
export function normCode(code: string | null | undefined): string {
  if (!code) return "";
  const [prefix, ...rest] = code.split(" ");
  const printed = BASES[prefix];
  return printed && rest.length ? printed + rest.join(" ") : code;
}

const TOKEN = /\s*\bnorm_unassigned\b/g;
const RESEARCH: Record<string, string> = {
  high: "уверенность высокая", medium: "уверенность средняя", low: "уверенность низкая",
  none: "подходящей нормы не найдено",
};
// The engine's reasons for not applying a norm by itself. Once a norm is set they no longer apply.
const AUTO_BLOCK = /^Автоматически не применена: (?:выбрана не ТЕР Московской области|нормативная база не выбрана|нормы применяются автоматически только для ТЕР Московской области)/;
const LEGACY_BLOCK = "Автоматически не применена: выбрана не ТЕР Московской области.";
const NOT_TER_MO = "Автоматически не применена: нормы применяются автоматически только для ТЕР Московской области, в этой базе норму выбирает сметчик.";

/** Notes of the norm choice: once each, without the engine's marker, in Russian. */
export function normNotes(notes: unknown, hasNorm: boolean): string[] {
  const list = Array.isArray(notes) ? notes.filter((note): note is string => typeof note === "string") : [];
  const cleaned = list.map(note => {
    const text = note.replace(TOKEN, "").trim()
      .replace(/^Исследование нормативки: (high|medium|low|none)\./, (_, level: string) => `Исследование нормативки: ${RESEARCH[level]}.`);
    // ФСНБ-2022 was chosen on purpose: the old wording read as if the wrong base were chosen.
    return text === LEGACY_BLOCK ? NOT_TER_MO : text;
  });
  return [...new Set(cleaned)].filter(note => note && !(hasNorm && AUTO_BLOCK.test(note)));
}
